import { luftGet } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

// ACTIONS
const GET_WAREHOUSE_DATA =
  'luft/operational-dashboard-warehouse/GET_WAREHOUSE_DATA';
const GET_WAREHOUSE_DATA_SUCCESS =
  'luft/operational-dashboard-warehouse/GET_WAREHOUSE_DATA_SUCCESS';
const GET_WAREHOUSE_DATA_FAILURE =
  'luft/operational-dashboard-warehouse/GET_WAREHOUSE_DATA_FAILURE';

// REDUCER
const INITIAL_STATE = {
  isFetching: false,
  error: false,
  data: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_WAREHOUSE_DATA:
      return {
        ...state,
        isFetching: true,
        error: false,
      };
    case GET_WAREHOUSE_DATA_SUCCESS:
      return {
        ...state,
        data: action.data,
        isFetching: false,
      };
    case GET_WAREHOUSE_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
};

// ACTION CREATORS
const _getWarehouseData = () => ({
  type: GET_WAREHOUSE_DATA,
});
const _getWarehouseDataSuccess = data => ({
  type: GET_WAREHOUSE_DATA_SUCCESS,
  data,
});
const _getWarehouseDataFailure = error => ({
  type: GET_WAREHOUSE_DATA_FAILURE,
  error,
});

// THUNK ACTION CREATORS
export const getWarehouseData = searchParams => async dispatch => {
  dispatch(_getWarehouseData());
  try {
    const response = await luftGet(
      '/DashboardOperational/Warehouse',
      searchParams,
    );
    dispatch(_getWarehouseDataSuccess(response.data));
  } catch (error) {
    loggedUserRequestErrorHandler(
      dispatch,
      error,
      _getWarehouseDataFailure(error.message),
    );
  }
};
